//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
export default {
  mixins: [blok],
  data () {
    return {
      priceListData: null,
      monthly: false,
      detailsOpen: false
    }
  },
  computed: {
    priceListName () {
      return this.blok.price_list_name
    },
    displayType () {
      return this.blok.display_type
    },
    isShowMoreButtonEnabled () {
      return this.blok.show_more_button
    },
    isPeriodToggleEnabled () {
      return this.blok.period_toggle
    },
    afterword () {
      return this.blok.afterword
    },
    title () {
      return this.blok.title
    },
    description () {
      return this.blok.description
    },
    promotedFeatures () {
      const customisedFeatures = (this.blok.promoted_features?.split?.(',') ?? []).filter(Boolean).map(feature => feature.trim())
      if (customisedFeatures.length) {
        return customisedFeatures
      }
      return this.priceListData?.data?.promoted_features ?? []
    },
    priceListPlans () {
      return (this.priceListData?.items ?? []).filter(plan => !plan.data?.upgrade_only)
    },
  },
  watch: {
    priceListName: {
      handler () {
        this.getPriceListData()
      },
      immediate: true
    }
  },
  methods: {
    async getPriceListData () {
      const response = await this.$api.getPriceList(this.priceListName)
      this.priceListData = response.data
    },
    promotedFeaturesForPlan (plan, isMonthly = false) {
      return this.promotedFeatures.map((featureId) => {
        const feature = this.priceListData?.data?.features?.find(({ id }) => id === featureId)
        const planFeatures = Array.isArray(plan.data.features)
          ? plan.data.features
          : typeof plan.data.features === 'object' && !!plan.data.features
            ? plan.data.features[isMonthly ? 'month' : 'year']
            : []

        const planFeature = planFeatures.find(({ id }) => id === featureId)

        if (!feature || !planFeature) {
          return feature
        }

        return {
          ...feature,
          planFeature
        }
      })
    },
    getFormattedPlanPrice (plan) {
      const price = plan.prices.find(price => this.monthly ? price.period_unit === 'month' : price.period_unit === 'year')
      return this.$n((price.monthly_price ?? 0) / 100, 'currency')
    }
  }
}
